import { motion } from "framer-motion";
import foot3 from "../images/foot3.jpg";
import foot4 from "../images/foot4.jpg";

const About = () => {
  const contentBlocks = [
    {
      title: "What is The Brotherhood",
      image: foot3,
      imageAlt: "Brotherhood leadership",
      overlayImage: foot4,
      overlayAlt: "Global mission placeholder",
      paragraphs: [
        "Brotherhood means God, Christ and the Angels. It means the people of this world, the fishes in the water, the trees in the forests, the grasses that grow in the fields. It means the ground on which we walk. Brotherhood means the Sky, the Wind, the Moon, the Sun, and the Stars. It means the worms, the ants, the birds. Brotherhood means every four-footed animal and every creeping thing. In short, Brotherhood means oneness. God and everything created by Him put together are Brotherhood. - Leader Olumba Olumba Obu",
      ],
    },
    {
      title: "The Spiritual School",
      image: foot4,
      imageAlt: "Brotherhood historical development",
      overlayImage: foot3,
      overlayAlt: "Institutional milestones placeholder",
      paragraphs: [
        "BCS is otherwise known as Christ’s Universal Spiritual School of Practical Christianity where people come to learn and apply the universal teachings of Christ. This means trying to put into practice the ways of Christ as embodied in a lifestyle of selflessness, universal love, oneness, peace, humility, forgiveness, kindness, generosity, compassion, understanding, and tolerance. It is also about faith, endurance, zeal, and determination to overcome all the challenges that life throws at us through applying the teachings of Our Lord Jesus Christ.",
        "Brotherhood denotes the unity of all creation and the oneness which is maintained by universal love. Cross relates to the suffering endured by those who have undertaken to follow the way of Christ to reach the Star; which is the reward and fulfilment of God’s purposes for humanity.",
      ],
    },
    {
      title: "The Theocratic Government",
      image: foot3,
      imageAlt: "Brotherhood faith community",
      overlayImage: foot4,
      overlayAlt: "Doctrinal community placeholder",
      paragraphs: [
        "In the Scriptures, Prophets Daniel and Isaiah allude to a new system of government in which righteousness and justice will be established on the earth. Christ called it ‘The Kingdom of God' and told His disciples to pray for its manifestation in The Lord’s Prayer: ‘Thy kingdom come, Thy will be done on earth as it is in Heaven. In the Old Testament, Daniel spoke of a kingdom that would be established by God on earth and would ‘break in pieces and consume all other kingdoms’ (Daniel 2:44) Isaiah foresaw a government that would rest upon the shoulders of the son of God (Isaiah 9:6-7).",
        "The Book of Revelation goes further to envision that ‘the kingdoms of this world become The Kingdoms of our Lord, and of His Christ, and He shall reign forever and ever.’ (Revelation 11: 15)",
      ],
    },
  ];

  return (
    <motion.main
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 1.1,
        delay: 0.2,
        ease: [0, 0.71, 0.2, 1.01],
      }}
      className="relative z-0 w-full bg-white text-slate-900"
    >
      <header className="relative z-0 pt-24 mt-24 md:pt-32 px-6 md:px-20 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[20px] h-[20px] rounded-full bg-blue-200/40 blur-[10px]" />
          <div className="absolute bottom-0 left-1/4 w-[10px] h-[10px] rounded-full bg-blue-100/50 blur-[10px]" />
          <div className="absolute bottom-0 right-1/4 w-[10px] h-[10px] rounded-full bg-indigo-100/50 blur-[10px]" />
        </div>

        <div className="relative max-w-5xl mx-auto flex flex-col items-center text-center gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="inline-flex items-center gap-4"
          >
            <span className="h-[1px] w-10 bg-blue-500" />
            <span className="text-blue-600 font-bold text-[10px] tracking-[0.45em] uppercase">
              Brotherhood of the Cross and Star
            </span>
            <span className="h-[1px] w-10 bg-blue-500" />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="space-y-4"
          >
            <h1 className="text-5xl md:text-7xl font-black text-stone-900 tracking-tighter leading-none uppercase">
              About <span className="text-blue-600 italic">Us.</span>
            </h1>
            <p className="text-stone-500 text-base md:text-xl font-medium leading-relaxed max-w-3xl mx-auto">
              Christ Universal Spiritual School of Practical Christianity
              <br /> The New Kingdom of God on Earth
            </p>
          </motion.div>
        </div>
      </header>

      <section className="px-6 md:px-20 py-16 md:py-28 space-y-28">
        {contentBlocks.map((block, index) => {
          const isOdd = index % 2 !== 0;
          const overlayAlignmentClass = isOdd ? "-left-10" : "-right-10";

          return (
            <article
              key={block.title}
              className="grid md:grid-cols-2 gap-14 md:gap-24 items-center"
            >
              <div className={isOdd ? "md:order-2" : ""}>
                <div className="relative">
                  <img
                    src={block.image}
                    alt={block.imageAlt}
                    className="w-full h-[300px] md:h-[420px] object-cover border border-slate-300"
                  />
                  <img
                    src={block.overlayImage}
                    alt={block.overlayAlt}
                    className={`hidden md:block absolute -bottom-10 ${overlayAlignmentClass} w-[46%] h-[180px] object-cover border-4 border-white shadow-xl`}
                  />
                </div>
              </div>

              <div className={`${isOdd ? "md:order-1" : ""} md:px-6 lg:px-10`}>
                <h2 className="text-2xl md:text-4xl leading-tight font-semibold text-slate-900">
                  {block.title}
                </h2>
                <div className="mt-6 space-y-4 text-base md:text-lg leading-relaxed text-slate-700">
                  {block.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </article>
          );
        })}
      </section>
    </motion.main>
  );
};

export default About;
